"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = exports.Title = exports.Header = void 0;
const native_1 = __importDefault(require("styled-components/native"));
const Typography_1 = require("../../../atoms/Typography/Typography");
exports.Header = native_1.default.View `
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: ${({ theme }) => `${theme.bpCore.gridSize * 3}px`};
  padding-right: ${({ theme }) => `${theme.bpCore.gridSize * 3}px`};
  flex-direction: row;
  position: relative;
  border-bottom-width: ${({ borderBottom }) => (borderBottom ? '1px' : '0px')};
  border-bottom-color: ${({ theme }) => theme.bpCore.colors.neutral[300]};
`;
exports.Title = native_1.default(Typography_1.Heading5) `
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  text-align: center;
  line-height: 30px;
  padding-right: 24px;
  padding-left: 24px;
`;
exports.CloseButton = native_1.default.TouchableOpacity `
  position: absolute;
  right: 24px;
  height: 32px;
  width: 32px;
  top: 12px;
  align-items: center;
  justify-content: center;
`;
